export default __webpack_public_path__ + "static/media/support_platform_drainage2.18ae957e.png";